





























































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import BasicStatisticCard from '@/components/common/BasicStatisticCard.vue';
import {
  DateFilter,
  DamageRegulationType,
  DamageStatus,
  IDamage,
  IPolicy,
  IProduct,
  ITag,
  ITaskCountsResult,
  IUser,
  PolicyStatus,
  TaskFilterDto,
} from 'admiral-core';
import { BaseMixin } from '@/mixins/BaseMixin';
import { PolicyApi } from '@/services/PolicyApi';
import { DamageApi } from '@/services/DamageApi';
import StatisticCardIcon from '@/views/pages/statistics/StatisticCardIcon.vue';
import {
  ArrowUpRightIcon,
  CheckCircleIcon,
  ClockIcon,
  CrosshairIcon,
  DollarSignIcon,
  ShoppingCartIcon,
  XCircleIcon,
} from 'vue-feather-icons';
import VueApexCharts from 'vue-apexcharts';
import RadialBarChart from '@/views/pages/statistics/RadialBarChart.vue';
import PolicyStatusProgress from '@/views/pages/policies/PolicyStatusProgress.vue';
import DamageStatusProgress from '@/views/pages/statistics/DamageStatusProgress.vue';
import DamageRegulationStatisticsCard, {
  DamageStatistics,
} from '@/views/pages/statistics/DamageRegulationStatisticsCard.vue';
import { FormatMixin } from '@/mixins/FormatMixin';
import { mixins } from 'vue-class-component';
import { TaskApi } from '@/services/TaskApi';
// ToDo nicht von admiral-core
import { StatisticFilterDTO } from 'admiral-core/dist/dtos/policy/statistic-filter.dto';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import StackedBarLineChart from './StackedBarLineChart.vue';
import ColumnChart from './ColumnChart.vue';
import StackedColumnChart from './StackedColumnChart.vue';
import DeclinedReasonsPieChart from './DeclinedReasonsPieChart.vue';
dayjs.locale('de');

Vue.component('apexchart', VueApexCharts);
interface QV {
  quantity: number;
  value: number;
}
interface Result {
  quantity: number;
  value: number;
  products: {
    [key: string]: {
      quantity: number;
      value: number;
      PLANNED: QV;
      OPEN: QV;
      SUBMITTED: QV;
      POLICED: QV;
      DECLINED: QV;
      CANCELED: QV;
    };
  };
  PLANNED: QV;
  OPEN: QV;
  OPEN70: QV;
  SUBMITTED: QV;
  POLICED: QV;
  DECLINED: QV;
  CANCELED: QV;
}

export type DeclinedReasonType =
  | 'Preis'
  | 'Kein Bedarf/Interesse'
  | 'Zu komplex'
  | 'Nicht erreicht'
  | 'Nicht dringend'
  | 'Sonstiges';

interface DeclinedReasonCount {
  reason: DeclinedReasonType;
  count: number;
}

interface DamageResult {
  quantity: number;
  value: number;
  NEW: QV;
  IN_PROGRESS: QV;
  PENDING: QV;
  SUBMITTED: QV;
  COMPLETED: QV;
  DECLINED: QV;
}

type TrackedDamageStatus = Exclude<DamageStatus, DamageStatus.DELETED>;

/** Prüft, ob ein Schaden-Status in der Statistik erfasst wird. */
function isTrackedDamageStatus(status: DamageStatus): status is TrackedDamageStatus {
  return status !== DamageStatus.DELETED;
}

type StatisticView = 'policies' | 'damages';

@Component({
  components: {
    DamageRegulationStatisticsCard,
    DamageStatusProgress,
    PolicyStatusProgress,
    RadialBarChart,
    StackedColumnChart,
    ColumnChart,
    StatisticCardIcon,
    BasicStatisticCard,
    apexChart: VueApexCharts,
    CrosshairIcon,
    ClockIcon,
    CheckCircleIcon,
    XCircleIcon,
    DollarSignIcon,
    ArrowUpRightIcon,
    ShoppingCartIcon,
    StackedBarLineChart,
    DeclinedReasonsPieChart,
  },
})
export default class Statistics extends mixins(BaseMixin, FormatMixin) {
  statisticView: StatisticView = 'policies';

  statisticViewOptions = [
    { text: 'Anbahnungen', value: 'policies' },
    { text: 'Schaden', value: 'damages' },
  ];

  damages: IDamage[] = [];
  policies: IPolicy[] = [];
  policiesAllTime: IPolicy[] = [];
  policiesWithoutProducts: IPolicy[] = [];
  labelsMixedChart: string[] = [];

  taskCounts: ITaskCountsResult = {
    ALL: 0,
    COMPLETED: 0,
    ARCHIVED: 0,
    IMPORTANT: 0,
    TODO: 0,
    BACKOFFICE: 0,
  };
  series: ApexNonAxisChartSeries = [];
  isLoading = false;
  results: Result = {
    value: 0,
    quantity: 0,
    ['PLANNED']: {
      value: 0,
      quantity: 0,
    },
    ['OPEN']: {
      value: 0,
      quantity: 0,
    },
    ['SUBMITTED']: {
      value: 0,
      quantity: 0,
    },
    ['POLICED']: {
      value: 0,
      quantity: 0,
    },
    ['DECLINED']: {
      value: 0,
      quantity: 0,
    },
    ['CANCELED']: {
      value: 0,
      quantity: 0,
    },
    ['OPEN70']: {
      value: 0,
      quantity: 0,
    },
    products: {},
  };
  damageResults: DamageResult = {
    quantity: 0,
    value: 0,
    NEW: { value: 0, quantity: 0 },
    IN_PROGRESS: { value: 0, quantity: 0 },
    PENDING: { value: 0, quantity: 0 },
    SUBMITTED: { value: 0, quantity: 0 },
    COMPLETED: { value: 0, quantity: 0 },
    DECLINED: { value: 0, quantity: 0 },
  };

  async mounted() {
    await this.loadPolicies(this.statisticFilter);
    await this.loadTasks(this.statisticFilter);
    await this.loadPoliciesAllTime(this.statisticFilter);
    await this.loadDamages();

    this.$root.$on('change-policy-filter', () => {
      this.loadPolicies(this.statisticFilter);
      this.loadPoliciesAllTime(this.statisticFilter);
      this.loadDamages();
    });
    this.$root.$on('change-task-filter', () => {
      this.loadTasks(this.statisticFilter);
    });
  }
  get statisticFilter() {
    return this.$store.getters[`PreferencesModule/getStatisticFilter`];
  }

  /** Schäden nach Statistik-Filter (Benutzer, Produkte, Tags). */
  get filteredDamages(): IDamage[] {
    let filtered = [...this.damages];
    const filter = this.statisticFilter;

    if (filter.users && filter.users.length > 0) {
      const userIds = filter.users.map((u: IUser) => u.id);
      filtered = filtered.filter((damage) => damage.user && userIds.includes(damage.user.id));
    }

    if (filter.products && filter.products.length > 0) {
      const productIds = filter.products.map((p: IProduct) => p.id);
      filtered = filtered.filter(
        (damage) => damage.product && productIds.includes(damage.product.id),
      );
    }

    if (filter.tags && filter.tags.length > 0) {
      const tagIds = filter.tags.map((t: ITag) => t.id);
      filtered = filtered.filter((damage) => {
        if (!damage.tags || damage.tags.length === 0) return false;
        return damage.tags.some((tag) => tagIds.includes(tag.id));
      });
    }

    return filtered;
  }

  getDamagesByStatuses(statuses: DamageStatus[]): IDamage[] {
    return this.filteredDamages.filter((damage) => statuses.includes(damage.status));
  }

  /** Ordnet legacy und aktuelle Regulierungswerte einer Regulierungsart zu. */
  normalizeRegulationType(regulationType?: string): DamageRegulationType | null {
    if (!regulationType) {
      return null;
    }

    if (regulationType === DamageRegulationType.AGENCY || regulationType === 'new') {
      return DamageRegulationType.AGENCY;
    }

    if (regulationType === DamageRegulationType.CENTRAL || regulationType === 'substitute') {
      return DamageRegulationType.CENTRAL;
    }

    return null;
  }

  /** Berechnet Kennzahlen für eine Gruppe von Schäden. */
  buildDamageStatistics(damages: IDamage[]): DamageStatistics {
    const openStatuses = [
      DamageStatus.NEW,
      DamageStatus.IN_PROGRESS,
      DamageStatus.PENDING,
      DamageStatus.SUBMITTED,
    ];

    return {
      count: damages.length,
      sumValue: damages.reduce((acc, damage) => acc + this.parseDamageValue(damage.value), 0),
      open: damages.filter((damage) => openStatuses.includes(damage.status)).length,
      completed: damages.filter((damage) => damage.status === DamageStatus.COMPLETED).length,
      declined: damages.filter((damage) => damage.status === DamageStatus.DECLINED).length,
    };
  }

  /** Schäden einer Regulierungsgruppe (Agentur oder Zentral). */
  getDamagesByRegulation(regulationType: DamageRegulationType): IDamage[] {
    return this.filteredDamages.filter(
      (damage) => this.normalizeRegulationType(damage.regulationType) === regulationType,
    );
  }

  get agencyDamageStatistics(): DamageStatistics {
    return this.buildDamageStatistics(
      this.getDamagesByRegulation(DamageRegulationType.AGENCY),
    );
  }

  get centralDamageStatistics(): DamageStatistics {
    return this.buildDamageStatistics(
      this.getDamagesByRegulation(DamageRegulationType.CENTRAL),
    );
  }

  get damageOpenCount() {
    return this.getDamagesByStatuses([
      DamageStatus.NEW,
      DamageStatus.IN_PROGRESS,
      DamageStatus.PENDING,
      DamageStatus.SUBMITTED,
    ]).length;
  }

  get damageCompletedCount() {
    return this.getDamagesByStatuses([DamageStatus.COMPLETED]).length;
  }

  get damageDeclinedCount() {
    return this.getDamagesByStatuses([DamageStatus.DECLINED]).length;
  }

  getPoliciesByStatuses(statuses: PolicyStatus[]): IPolicy[] {
    return this.policies.filter((policy) => statuses.includes(policy.status));
  }

  get abschlussQuote() {
    const relevantPolicies = this.getPoliciesByStatuses([
      PolicyStatus.POLICED,
      PolicyStatus.SUBMITTED,
      PolicyStatus.DECLINED,
    ]);

    const total = relevantPolicies.length;
    const declined = relevantPolicies.filter((p) => p.status === PolicyStatus.DECLINED).length;

    const quote = total > 0 ? (1 - declined / total) * 100 : 0;
    return quote.toFixed() + '%';
  }

  get sumTypeNew() {
    return this.getPoliciesByStatuses([PolicyStatus.POLICED, PolicyStatus.SUBMITTED]).filter(
      (policy) => policy.type === 'new',
    ).length;
  }

  get sumTypeSubstitute() {
    return this.getPoliciesByStatuses([PolicyStatus.POLICED, PolicyStatus.SUBMITTED]).filter(
      (policy) => policy.type === 'substitute',
    ).length;
  }

  get sumJahresNettoBeitrag() {
    let sum = 0;
    this.getPoliciesByStatuses([PolicyStatus.POLICED, PolicyStatus.SUBMITTED]).forEach((policy) => {
      if (policy.jahresNettoBeitrag) {
        sum += Number(policy.jahresNettoBeitrag);
      }
    });
    return sum;
  }

  get stackedColumnChartData() {
    const relevantPolicies = this.policiesWithoutProducts.filter((policy: any) =>
      ['POLICED', 'SUBMITTED'].includes(policy.status),
    );

    // Summiere pro Produkt den Gesamtwert
    const productValues = this.products.map((product: any) => {
      const totalValue = relevantPolicies
        .filter((policy: any) => policy.product && policy.product.id === product.id)
        .reduce((sum: number, policy: any) => sum + (policy.value || 0), 0);

      return {
        name: product.name,
        value: totalValue,
        data: [totalValue],
      };
    });

    const productsWithValue = productValues.filter((product: any) => product.value > 0);
    const sortedProducts = productsWithValue.sort((a: any, b: any) => b.value - a.value);

    if (sortedProducts.length < 8) {
      return sortedProducts;
    }

    // Top 6 und Rest zusammenfassen
    const top6 = sortedProducts.slice(0, 6);
    const rest = sortedProducts.slice(6);
    const restValue = rest.reduce((sum, product) => sum + product.value, 0);

    return [
      ...top6,
      {
        name: 'Rest',
        data: [restValue],
        value: restValue,
      },
    ];
  }

  get restProducts() {
    const sortedProducts = this.products
      .map((product: any) => {
        const totalValue = this.policiesWithoutProducts
          .filter(
            (policy: any) =>
              ['POLICED', 'SUBMITTED'].includes(policy.status) &&
              policy.product &&
              policy.product.id === product.id,
          )
          .reduce((sum: number, policy: any) => sum + (policy.value || 0), 0);

        return {
          name: product.name,
          value: totalValue,
        };
      })
      .sort((a: any, b: any) => b.value - a.value);

    return sortedProducts.slice(6);
  }

  get stackedBarLineChartData() {
    const productsData = this.products.map((product) => {
      const relevantPolicies = this.policiesWithoutProducts.filter(
        (policy) =>
          [PolicyStatus.POLICED, PolicyStatus.SUBMITTED, PolicyStatus.OPEN].includes(
            policy.status,
          ) &&
          policy.product &&
          policy.product.id === product.id,
      );

      const policedValue = relevantPolicies
        .filter((policy) => policy.status === PolicyStatus.POLICED)
        .reduce((sum, p) => sum + (p.value || 0), 0);

      const submittedValue = relevantPolicies
        .filter((policy) => policy.status === PolicyStatus.SUBMITTED)
        .reduce((sum, p) => sum + (p.value || 0), 0);

      const openValue = relevantPolicies
        .filter((policy) => policy.status === PolicyStatus.OPEN)
        .reduce((sum, p) => sum + (p.value || 0), 0);

      const policedQuantity = relevantPolicies
        .filter((policy) => policy.status === PolicyStatus.POLICED)
        .reduce((sum, p) => sum + (p.quantity || 0), 0);

      const submittedQuantity = relevantPolicies
        .filter((policy) => policy.status === PolicyStatus.SUBMITTED)
        .reduce((sum, p) => sum + (p.quantity || 0), 0);

      const openQuantity = relevantPolicies
        .filter((policy) => policy.status === PolicyStatus.OPEN)
        .reduce((sum, p) => sum + (p.quantity || 0), 0);

      const quantity = policedQuantity + submittedQuantity + openQuantity;

      return {
        name: product.name,
        policedValue,
        submittedValue,
        openValue,
        policedQuantity,
        submittedQuantity,
        openQuantity,
        quantity,
      };
    });

    const filteredProducts = productsData.filter((item) => item.quantity !== 0);
    filteredProducts.sort(
      (a, b) => b.policedValue + b.submittedValue - (a.policedValue + a.submittedValue),
    );

    const labels = filteredProducts.map((item) => item.name);

    const policedData = filteredProducts.map((item) => ({
      value: item.policedValue,
      quantity: item.policedQuantity,
    }));
    const submittedData = filteredProducts.map((item) => ({
      value: item.submittedValue,
      quantity: item.submittedQuantity,
    }));
    const openData = filteredProducts.map((item) => ({
      value: item.openValue,
      quantity: item.openQuantity,
    }));

    const quantityData = filteredProducts.map((item) => ({
      value: 0,
      quantity: item.quantity,
    }));

    return {
      labels,
      datasets: [
        {
          label: 'Policiert',
          backgroundColor: '#28C76F',
          data: policedData,
          yAxisID: 'y',
          stack: 'Stack 0',
          parsing: {
            xAxisKey: 'quantity',
            yAxisKey: 'value',
          },
        },
        {
          label: 'Eingereicht',
          backgroundColor: '#FF9F43',
          data: submittedData,
          yAxisID: 'y',
          stack: 'Stack 0',
          parsing: {
            xAxisKey: 'quantity',
            yAxisKey: 'value',
          },
        },
        {
          label: 'Offen',
          backgroundColor: '#82868A',
          data: openData,
          yAxisID: 'y',
          stack: 'Stack 0',
          parsing: {
            xAxisKey: 'quantity',
            yAxisKey: 'value',
          },
        },
        {
          type: 'line',
          label: 'Anzahl',
          borderColor: '#3A7BC7',
          backgroundColor: 'transparent',
          data: quantityData,
          yAxisID: 'y1',
          tension: 0,
          pointRadius: 4,
          pointBackgroundColor: '#3A7BC7',
          borderWidth: 3,
          parsing: {
            xAxisKey: 'value',
            yAxisKey: 'quantity',
          },
        },
      ],
    };
  }

  private _convertStatisticFilterToTaskFilter(
    statisticFilter: StatisticFilterDTO,
    overrides?: Partial<TaskFilterDto>,
  ): TaskFilterDto {
    const taskFilter: TaskFilterDto = {
      status: [],
      dateFilter: statisticFilter.dateFilter,
      users: statisticFilter.users,
      tags: statisticFilter.tags,
    };

    if (overrides) {
      Object.assign(taskFilter, overrides);
    }

    return taskFilter;
  }

  async loadTasks(filter: StatisticFilterDTO) {
    try {
      const filterTasks = this._convertStatisticFilterToTaskFilter(filter, {
        dateFilter: DateFilter.ALL,
        from: 0,
        to: new Date().getTime(),
      });

      const showDemo = this.$store.getters['PreferencesModule/getShowDemo'];
      const taskCountsResponse = await TaskApi.getTaskCounts({
        ...filterTasks,
        agency: this.user.agency,
        showDemo,
      });
      this.taskCounts = taskCountsResponse.data;
    } catch (e) {
      this.$toastr.e(
        'Beim Laden der Tasks ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      throw e;
    }
  }
  get radialBarChartData(): number[] {
    const total = this.taskCounts.COMPLETED + this.taskCounts.TODO;
    return total > 0 ? [Math.round((this.taskCounts.COMPLETED / total) * 100)] : [0];
  }

  get monthlySeries() {
    const monthlyData = new Array(12).fill(0);
    const currentDate = dayjs();

    this.policies
      .filter((policy) => {
        if (policy.status !== PolicyStatus.POLICED || !policy.policedAt) {
          return false;
        }
        const policedAtDate = dayjs(policy.policedAt);
        const businessYearDate = dayjs(policy.businessYear);

        // Falls businessYear nach policedAt liegt und das aktuelle Datum (Monat & Tag)
        // vor dem Datum von policedAt liegt (Monat & Tag), wird die Policy ausgeschlossen.
        if (
          businessYearDate.isAfter(policedAtDate) &&
          (currentDate.month() < policedAtDate.month() ||
            (currentDate.month() === policedAtDate.month() &&
              currentDate.date() < policedAtDate.date()))
        ) {
          return false;
        }

        return true;
      })
      .forEach((policy) => {
        const month = dayjs(policy.policedAt).month();
        monthlyData[month] += policy.value;
      });

    return monthlyData;
  }

  get yearlyOverviewSeries() {
    const yearlyData = this.policiesAllTime.reduce((acc, policy) => {
      const year = policy.businessYear ? dayjs(policy.businessYear).year().toString() : 'Unbekannt';

      if (!acc[year]) {
        acc[year] = 0;
      }
      acc[year] += Number(policy.value) || 0;
      return acc;
    }, {} as Record<string, number>);

    const sortedYears = Object.keys(yearlyData)
      .filter((year) => year !== 'Unbekannt')
      .sort((a, b) => Number(b) - Number(a));
    return sortedYears.map((year) => Math.round(yearlyData[year] || 0));
  }

  get yearlyCategories(): string[] {
    return [
      ...new Set(
        this.policiesAllTime
          .map((policy) =>
            policy.businessYear ? dayjs(policy.businessYear).year().toString() : null,
          )
          .filter((year): year is string => year !== null),
      ),
    ].sort((a, b) => Number(b) - Number(a));
  }

  get monthNames() {
    return Array.from({ length: 12 }, (_, i) => dayjs().month(i).format('MMMM'));
  }

  get declinedReasonCounts(): DeclinedReasonCount[] {
    const declinedPolicies = this.policies.filter(
      (policy) => policy.status === PolicyStatus.DECLINED && policy.declinedReason,
    );

    const counts: Record<string, number> = {};

    declinedPolicies.forEach((policy) => {
      const reason = policy.declinedReason as DeclinedReasonType;
      if (!counts[reason]) {
        counts[reason] = 0;
      }
      counts[reason]++;
    });

    return Object.entries(counts).map(([reason, count]) => ({
      reason: reason as DeclinedReasonType,
      count,
    }));
  }

  @Watch('statisticFilter', { deep: true })
  async onPolicyFilterChange() {
    await this.loadPolicies(this.statisticFilter);
    await this.loadPoliciesAllTime(this.statisticFilter);
    await this.loadTasks(this.statisticFilter);
    this.calculateDamages();
  }

  /** Parst Schadenhöhen sicher als Zahl. */
  parseDamageValue(value?: number | string | null): number {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  async loadDamages() {
    try {
      const showDemo = this.$store.getters['PreferencesModule/getShowDemo'];
      const response = await DamageApi.getDamages({
        agency: this.user.agency,
        showDemo,
      });
      this.damages = response.data;
      this.calculateDamages();
    } catch (e) {
      this.$toastr.e('Fehler beim Laden der Schäden');
      throw e;
    }
  }

  calculateDamages() {
    const results: DamageResult = {
      quantity: 0,
      value: 0,
      NEW: { value: 0, quantity: 0 },
      IN_PROGRESS: { value: 0, quantity: 0 },
      PENDING: { value: 0, quantity: 0 },
      SUBMITTED: { value: 0, quantity: 0 },
      COMPLETED: { value: 0, quantity: 0 },
      DECLINED: { value: 0, quantity: 0 },
    };

    this.filteredDamages.forEach((damage: IDamage) => {
      if (!isTrackedDamageStatus(damage.status)) {
        return;
      }

      const statusResult = results[damage.status];
      const damageValue = this.parseDamageValue(damage.value);

      results.quantity += 1;
      results.value += damageValue;
      statusResult.quantity += 1;
      statusResult.value += damageValue;
    });

    this.damageResults = results;
  }

  async loadPoliciesAllTime(filter?: StatisticFilterDTO) {
    try {
      this.isLoading = true;
      this.$Progress.start();
      if (!filter) {
        filter = {
          agency: this.user.agency,
        };
      }
      if (!filter.agency) {
        filter.agency = this.user.agency;
      }

      const filterWithoutDate = {
        ...filter,
        showDemo: this.$store.getters['PreferencesModule/getShowDemo'],
      };
      filterWithoutDate.status = [PolicyStatus.POLICED];
      filterWithoutDate.businessYear = undefined;
      filterWithoutDate.dateFilter = DateFilter.CUSTOM;
      filterWithoutDate.from = 0;
      filterWithoutDate.to = new Date().getTime();

      const policies = await PolicyApi.getPolicies(filterWithoutDate);
      this.policiesAllTime = policies.data as IPolicy[];
    } catch (e) {
      this.$toastr.e(
        'Beim Abrufen der Anbahnungen ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      this.isLoading = false;
      this.$Progress.finish();
      throw e;
    }
    this.isLoading = false;
    this.$Progress.finish();
  }

  async loadPolicies(filter?: StatisticFilterDTO) {
    try {
      this.isLoading = true;
      this.$Progress.start();
      if (!filter) {
        filter = {
          agency: this.user.agency,
        };
      }
      filter.agency = this.user.agency;

      const filterAll = {
        ...filter,
        showDemo: this.$store.getters['PreferencesModule/getShowDemo'],
      };

      const filterWithoutProducts = {
        ...filter,
        showDemo: this.$store.getters['PreferencesModule/getShowDemo'],
      };
      delete filterWithoutProducts.products;

      const [policiesResponse, policiesWithoutProductsResponse] = await Promise.all([
        PolicyApi.getPolicies(filterAll),
        PolicyApi.getPolicies(filterWithoutProducts),
      ]);

      this.policies = policiesResponse.data as IPolicy[];
      this.policiesWithoutProducts = policiesWithoutProductsResponse.data as IPolicy[];
      this.calculate();
    } catch (e) {
      this.$toastr.e(
        'Beim Abrufen der Anbahnungen ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      this.isLoading = false;
      this.$Progress.finish();
      throw e;
    }
    this.isLoading = false;
    this.$Progress.finish();
  }
  calculate() {
    const results: Result = {
      quantity: 0,
      value: 0,
      ['PLANNED']: {
        value: 0,
        quantity: 0,
      },
      ['OPEN']: {
        value: 0,
        quantity: 0,
      },
      ['SUBMITTED']: {
        value: 0,
        quantity: 0,
      },
      ['POLICED']: {
        value: 0,
        quantity: 0,
      },
      ['DECLINED']: {
        value: 0,
        quantity: 0,
      },
      ['CANCELED']: {
        value: 0,
        quantity: 0,
      },
      OPEN70: {
        value: 0,
        quantity: 0,
      },
      products: {},
    };
    this.products.forEach((product: IProduct) => {
      if (!results.products[product.id]) {
        results.products[product.id] = {
          value: 0,
          quantity: 0,
          ['PLANNED']: {
            value: 0,
            quantity: 0,
          },
          ['OPEN']: {
            value: 0,
            quantity: 0,
          },
          ['SUBMITTED']: {
            value: 0,
            quantity: 0,
          },
          ['POLICED']: {
            value: 0,
            quantity: 0,
          },
          ['DECLINED']: {
            value: 0,
            quantity: 0,
          },
          ['CANCELED']: {
            value: 0,
            quantity: 0,
          },
        };
      }
    });
    this.policies.forEach((policy: IPolicy) => {
      if (!policy.product) {
        return;
      }
      results.quantity += policy.quantity;
      results.value += policy.value;
      results.products[policy.product.id].quantity += policy.quantity;
      results.products[policy.product.id].value += policy.value;
      results.products[policy.product.id][policy.status].value += policy.value;
      results.products[policy.product.id][policy.status].quantity += policy.quantity;
      results[policy.status].quantity += policy.quantity;
      results[policy.status].value += policy.value;
      if (policy.status === PolicyStatus.OPEN && policy.probability >= 7) {
        results['OPEN70'].quantity += policy.quantity;
        results['OPEN70'].value += policy.value;
      }
    });
    this.results = results;
  }
}
